export class UrlParams {
    params: string[] = [];

    add(name: string, value: any, defVal: any = null) {
        if (value != null) {
            this.params.push(`${name}=${value}`);
        }
        else if (defVal != null) {
            this.params.push(`${name}=${defVal}`);
        }
    }

    addDate(name: string, value: Date) {
        if (value != null) {
            let dt = value.toDateString();
            this.params.push(`${name}=${dt}`);
        }
    }

    toString() {
        return this.params.join('&');
    }

    isEmpty() {
        return this.params.length == 0 ? true : false;
    }
}
